import React from 'react';
import { Checkbox as AntdCheckbox, CheckboxProps } from 'antd';
import styled from '@emotion/styled';

const StyledCheckbox = styled(AntdCheckbox)``;
const Checkbox = (props: CheckboxProps) => {
  return <StyledCheckbox {...props}></StyledCheckbox>;
};

Checkbox.Group = AntdCheckbox.Group;

export default Checkbox;
